const WasteManagementReportsMenu = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_2346_7440)"
      fill-opacity="0.1"
    />
    <path
      d="M18.0661 7.75V11.8824H22.1986L18.0661 7.75ZM17.0256 11.8824V7.75H11.3472C10.4851 7.75 9.80127 8.43378 9.80127 9.29595V22.7041C9.80127 23.5662 10.4851 24.25 11.3472 24.25H20.6526C21.5148 24.25 22.1986 23.5662 22.1986 22.7041V12.8932H18.0959C17.5013 12.923 17.0256 12.4473 17.0256 11.8824ZM18.5715 21.1581H13.4283C13.131 21.1581 12.9229 20.9203 12.9229 20.6527C12.9229 20.3554 13.1607 20.1473 13.4283 20.1473H18.6013C18.8986 20.1473 19.1067 20.3851 19.1067 20.6527C19.1067 20.95 18.8688 21.1581 18.5715 21.1581ZM18.5715 19.1068H13.4283C13.131 19.1068 12.9229 18.8689 12.9229 18.6014C12.9229 18.3041 13.1607 18.0959 13.4283 18.0959H18.6013C18.8986 18.0959 19.1067 18.3338 19.1067 18.6014C19.1067 18.8689 18.8688 19.1068 18.5715 19.1068ZM19.1067 16.5203C19.1067 16.8176 18.8688 17.0257 18.6013 17.0257H13.4283C13.131 17.0257 12.9229 16.7878 12.9229 16.5203C12.9229 16.223 13.1607 16.0149 13.4283 16.0149H18.6013C18.8688 16.0149 19.1067 16.2527 19.1067 16.5203Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2346_7440"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default WasteManagementReportsMenu
